import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
 import "./ApplicationMain.css";
import InstitutionHeader from "./components/InstitutionHeader";
import { INSTITUTION_ASSETS } from "../../s3-assets/Institution";

const ApplicationMain = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/re-login");
  };
  const handleAdmission = () => {
    // navigate("/application"); 
    navigate("/application-reg");

  };
  const handleEnquiry = () => {
    navigate("/enquiry");
  };

  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
     const storedLogoUrl = localStorage.getItem('companyLogo');
    if (storedLogoUrl) {
      setLogoUrl(storedLogoUrl);
    }
  }, []);
  return (
    <>
      <br />    <br />
      <br />

      <div className="min-h-screen overflow-hidden relative scroll-smooth">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source src={INSTITUTION_ASSETS.VIDEO_BACKGROUND} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Content Container */}
        <div className="flex h-screen bg- relative overflow-hidden">

          <div className="flex mx-auto my-auto w-full max-w-5xl h-[90%] bg-white bg-opacity-90 rounded-lg shadow-xl overflow-hidden relative z-10">
            <InstitutionHeader />
            {/* Left Side: Image */}
            <div className="flex-1 flex items-center justify-center p-0">
              <img
                src={INSTITUTION_ASSETS.MAINPAGE_IMAGES.IMAGE_1}
                alt="Application Registration"
                className="w-full h-full object-cover rounded-lg shadow-lg transition-transform duration-300 hover:scale-105 border-4 border-gray-300 contrast-125"
              />

            </div>

            {/* Right Side: Registration Form */}
            <div className="flex flex-col items-center justify-center p-8 bg-[#F9FAFB] bg-opacity-90 rounded-lg max-w-md w-full space-y-6">
              {/* Logo */}
              <img
               src={logoUrl}
                 alt="Company logo"
                 className="w-36 h-auto object-contain mb-4 animate-fade-in"
              />

              {/* Title */}
              <h2 className="text-3xl font-bold text-blue-600 text-center animate-slide-up">
                Online Application Registration for
                <br />
                {/* {new Date().getFullYear()} - {new Date().getFullYear() + 1} */}
                2025 - 2026
              </h2>


              {/* Buttons */}
              <div className="space-y-4 w-full animate-fade-in">
                <button
                  onClick={handleEnquiry}
                  className="w-full py-3 bg-gradient-to-r from-red-500 to-red-700 text-white rounded-md font-semibold hover:from-red-600 hover:to-red-800 transition duration-200 ease-in-out shadow-md transform hover:scale-105"
                >
                  New Enquiry
                </button>
                <button
                  onClick={handleAdmission}
                  className="w-full py-3 bg-gradient-to-r from-red-500 to-red-700 text-white rounded-md font-semibold hover:from-red-600 hover:to-red-800 transition duration-200 ease-in-out shadow-md transform hover:scale-105"
                >
                  Buy Application
                </button>
                <button
                  className="w-full py-3 bg-gradient-to-r from-blue-500 to-blue-700 text-white rounded-md font-semibold hover:from-blue-600 hover:to-blue-800 transition duration-300 transform hover:scale-105 ease-in-out shadow-lg"
                  onClick={handleLoginClick} // Add onClick handler
                >
                  Already Applied - Login
                </button>
              </div>

              {/* Footer */}
              <footer className="text-center text-gray-500 text-xs mt-6 animate-fade-in">
                © Velammal Institution 2024 - All Rights Reserved.{" "}
                <span className="font-semibold">Krumago</span>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplicationMain;
